import React from 'react';
// BUILD TIMESTAMP: 2026-04-11T21:00:00Z - FORCES FRESH COMPILE
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);